export default "__VITE_ASSET__B7uM8mEr__"